import { useFormikContext } from "formik";
import { useActionModalGetContext } from "context/ActionModalProvider";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import WateringSuggestion from "./WateringSuggestion";
import WateringPerformed from "./WateringPerformed";
import checkIfPerformedWithSuggested from "components/action-modal/utils/checkIfPerformedWithSuggested";

const WateringDetails = ({ viewMode, status, isNewVersion }) => {
  const { values } = useFormikContext();
  const { fieldInfo } = useActionModalGetContext();

  const operationTypeId = fieldInfo.wateringMechanismRead?.id;

  const isPerformedWithSuggested = checkIfPerformedWithSuggested(values);

  if (
    viewMode === ACTION_VIEW_MODE.view ||
    viewMode === ACTION_VIEW_MODE.edit
  ) {
    if (status !== ACTION_STATUS.performed) {
      return (
        <WateringSuggestion
          viewMode={viewMode}
          isFullWidth
          operationTypeId={operationTypeId}
        />
      );
    } else if (isPerformedWithSuggested) {
      return (
        <div className="action-details-both-box-wrapper">
          <WateringSuggestion
            viewMode={ACTION_VIEW_MODE.view}
            operationTypeId={operationTypeId}
            isProposedValue
          />
          <WateringPerformed
            viewMode={viewMode}
            operationTypeId={operationTypeId}
          />
        </div>
      );
    } else {
      return (
        <WateringPerformed
          viewMode={viewMode}
          isFullWidth
          operationTypeId={operationTypeId}
        />
      );
    }
  } else if (viewMode === ACTION_VIEW_MODE.new) {
    if (status !== ACTION_STATUS.performed) {
      return (
        <WateringSuggestion
          viewMode={viewMode}
          isFullWidth
          operationTypeId={operationTypeId}
          isNewVersion={isNewVersion}
        />
      );
    } else {
      return (
        <WateringPerformed
          viewMode={viewMode}
          isFullWidth
          operationTypeId={operationTypeId}
          isNewVersion={isNewVersion}
        />
      );
    }
  } else {
    return <></>;
  }
};

export default WateringDetails;
